class LayerGates{
	

	
	constructor(context) {
		
		this.scenario = context.tc.scenario;
		this.map = context.tc.draw.map;
		this.du = context.tc.draw;
		this.tc = context.tc;
		this.context = context;
		this.currentSensor = false;
		this.currentSensorIdx = false;
		
	}
	
	json(){
		var points = this.scenario.gates.slice(0);	
		LayerGates.data = {
			"type":"FeatureCollection",
			"features":[]
		};
			
		LayerGates.data.features = points.map((f, idx)=>{
			f.type = 'Feature';

			f.properties = {...f.properties};
			if(isNaN(f.id))
				f.properties.tempid = f.id;
			// else: f.id is already numeric — used as GeoJSON feature ID by MapLibre

			f.properties.idx = idx;
			f.properties.id = f.id;
			f.properties.name = f.name ? f.name : 'Gate ' + f.id;
			return f;
		});
		
		const l = {
			'images': [
				{
					'src': '/images/icons/gate_marker.png',
					'name': 'gatemarker'
				},
				{
					'src': '/images/icons/gate_marker_hover.png',
					'name': 'gatemarker_hover'
				},
				{
					'src': '/images/icons/gate_marker_on.png',
					'name': 'gatemarker_on'
				}
			],
			'source': {
				'id': LayerGates.sourceId,
				'type': 'geojson',
				'data': LayerGates.data
			},
			'layer': [
				{
					'id': LayerGates.layerId,
					'type': 'symbol',
					'source': LayerGates.sourceId,
					"paint": {
						'text-color': "#000000", //Color of your choice
						'text-halo-width': 1,
						'text-halo-color': "#ffffff",
					}, // reference the data source
					'layout': {
						'icon-image':['case',
							['boolean', ['get', 'invisible'], false],'',
							['boolean', ['get', 'selected'], false],'gatemarker_on',
							['boolean', ['get', 'hover'], false],'gatemarker_hover',
							'gatemarker'
						],
						'icon-anchor' : 'bottom',
						'icon-allow-overlap' : true,
						'text-field': ['case',
							['boolean', ['get', 'invisible'], false],'',
							['get', 'name']
						]	
						, //This will get "t" property from your geojson
						'text-rotation-alignment': "auto",
						'text-allow-overlap': true,
						'text-anchor': "top",
						'text-size': 14,
					},
				}
			]
		};
		return l;
	}
	
		
}

LayerGates.layerId = 'gates_layer';
LayerGates.sourceId = 'gates_source';


export default LayerGates;